import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 地址
 */
export default [
  //
  // 1.3 地址列表
  route('/addressEdit', 'addressEdit', resolve => require(['@/pages/payment/views/address/address-push'], resolve), {
    noKeepAlive: true
  }),
  // 1.3.1 填写地址
  route(
    '/addressListNew',
    'addressListNew',
    resolve => require(['@/pages/payment/views/address/address-list'], resolve),
    { noKeepAlive: true }
  )
]
